import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';

@Component({
  selector: 'app-loading-overlay',
  imports: [CommonModule, ProgressSpinnerComponent],
  template: `
    @if (visible()) {
      <div 
        [class]="overlayClasses"
        [attr.role]="'progressbar'"
        [attr.aria-label]="message() || 'Loading'">
        <div class="flex flex-col items-center justify-center gap-4">
          <app-progress-spinner [size]="size()" [variant]="variant()" [label]="message()" />
          @if (message()) {
            <p class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ message() }}</p>
          }
        </div>
      </div>
    }
  `,
  styles: []
})
export class LoadingOverlayComponent {
  visible = input<boolean>(false);
  message = input<string>('');
  size = input<'sm' | 'md' | 'lg'>('md');
  variant = input<'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'>('primary');
  backdrop = input<boolean>(true);

  get overlayClasses(): string {
    const classes = [
      'fixed',
      'inset-0',
      'z-[9999]',
      'flex',
      'items-center',
      'justify-center'
    ];

    if (this.backdrop()) {
      classes.push('bg-black/50', 'dark:bg-black/70', 'backdrop-blur-sm');
    } else {
      classes.push('bg-transparent');
    }

    return classes.join(' ');
  }
}

